import { useState } from "react";
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import "react-multi-date-picker/styles/layouts/mobile.css";
import moment from "jalali-moment";
import Modal from "@/src/components/Modal";

interface CustomDatePickerProps {
  setFrom: (timestamp: number) => void;
  setTo: (timestamp: number) => void;
  setShowFilter: (filter: string) => void;
  onClose: () => void;
}

function CustomDate({
  setFrom,
  setTo,
  setShowFilter,
  onClose,
}: CustomDatePickerProps) {
  const [startDate, setStartDate] = useState<DateObject | null>(null);
  const [endDate, setEndDate] = useState<DateObject | null>(null);
  const [isOpen, setIsOpen] = useState(true);

  const handleStartDateChange = (date: any | null) => {
    setStartDate(date);
  };

  const handleEndDateChange = (date: any | null) => {
    setEndDate(date);
  };

  const applyDateFilter = () => {
    if (startDate && endDate) {
      const startTimestamp = moment(
        moment(startDate.toDate()).format("YYYY/MM/DD"),
        "jYYYY/jMM/jDD"
      )
        .startOf("day")
        .valueOf();

      const endTimestamp = moment(
        moment(endDate.toDate()).format("YYYY/MM/DD"),
        "jYYYY/jMM/jDD"
      )
        .endOf("day")
        .valueOf();

      setFrom(startTimestamp);
      setTo(endTimestamp);
      setShowFilter(`${startDate.unix} تا ${endDate.unix}`);

      setIsOpen(false);
      onClose();
    } else {
      alert("لطفاً تاریخ شروع و پایان را انتخاب کنید");
    }
  };

  const handleCancel = () => {
    setIsOpen(false);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <Modal open={isOpen} onClose={onClose}>
      <div className="bg-white rounded-lg p-4 mb-20 max-w-md w-full">
        <h3 className="text-lg font-medium mb-4 text-center">
          انتخاب بازه زمانی
        </h3>

        <div className="mb-4">
          <label className="block text-sm font-medium mb-1 text-right">
            تاریخ شروع:
          </label>
          <DatePicker
            calendar={persian}
            locale={persian_fa}
            calendarPosition="bottom-right"
            value={startDate}
            onChange={handleStartDateChange}
            format="YYYY/MM/DD"
            inputClass="w-full rounded-lg border border-gray-300 p-2 text-right"
            placeholder="انتخاب تاریخ شروع"
          />
        </div>

        <div className="mb-6">
          <label className="block text-sm font-medium mb-1 text-right">
            تاریخ پایان:
          </label>
          <DatePicker
            calendar={persian}
            locale={persian_fa}
            calendarPosition="bottom-right"
            value={endDate}
            onChange={handleEndDateChange}
            format="YYYY/MM/DD"
            inputClass="w-full rounded-lg border border-gray-300 p-2 text-right"
            placeholder="انتخاب تاریخ پایان"
            minDate={startDate?.format("YYYY/MM/DD")}
          />
        </div>

        <div className="flex justify-between">
          <button
            onClick={handleCancel}
            className="bg-gray-200 text-gray-800 px-4 py-2 rounded-lg hover:bg-gray-300 transition-colors"
          >
            انصراف
          </button>
          <button
            onClick={applyDateFilter}
            className="bg-primary-300 text-white px-4 py-2 rounded-lg hover:bg-primary-400 transition-colors"
          >
            اعمال فیلتر
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default CustomDate;
